module.exports = __webpack_public_path__ + "static/03-c988075817b04f3e5efc82f940a10cf0.jpg";